import { fetchClient } from '@nike/fetch-client';
import getTranslationsQueryKey from './get-query-key';

// Pass language to enable query setup in get-static-props
var getFetchCartTranslationsOptions = function getFetchCartTranslationsOptions(_ref) {
  var language = _ref.language;
  return {
    queryKey: getTranslationsQueryKey({
      language: language
    }),
    queryFn: function queryFn() {
      return fetchClient("https://".concat(process.env.NEXT_PUBLIC_HOST_NAME, "/assets/i18n/dotcom-cart/").concat(language, ".json"));
    },
    enabled: Boolean(language)
  };
};
export default getFetchCartTranslationsOptions;